import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { PHONE, PHONE_HREF, FOOTER } from '../mock';

export default function Footer() {
  return (
    <footer className="relative pt-24 border-t border-[var(--line)] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-[1.3fr_0.9fr_0.9fr_0.9fr] gap-12">
          {/* Left */}
          <div>
            <div className="label-mono text-[var(--accent)] mb-6">Callout Desk · 24/7</div>
            <h3 className="font-display text-[clamp(2rem,4vw,3.2rem)] text-white">
              A live engineer, <span className="font-display-italic text-[#c3cbdb]">on the line.</span>
            </h3>
            <a href={PHONE_HREF} className="mt-8 inline-flex items-center gap-3 font-display text-[clamp(1.6rem,3vw,2.4rem)] text-white link-sweep">
              <Phone size={26} className="text-[var(--accent)]" /> {PHONE}
            </a>
          </div>

          {/* Contact */}
          <FootCol title="Contact">
            <li className="flex items-start gap-3"><Mail size={15} className="text-[var(--accent)] mt-1 shrink-0" /> {FOOTER.contact[0].text}</li>
            <li className="flex items-start gap-3"><MapPin size={15} className="text-[var(--accent)] mt-1 shrink-0" /> {FOOTER.contact[1].text}</li>
          </FootCol>

          <FootCol title="Services">
            {FOOTER.services.map((s) => <li key={s}>{s}</li>)}
          </FootCol>

          <FootCol title="Legal">
            {FOOTER.legal.map((s) => <li key={s}>{s}</li>)}
          </FootCol>
        </div>

        <div className="mt-16 border-t border-[var(--line)]" />
      </div>

      {/* Giant wordmark */}
      <div className="relative select-none pointer-events-none mt-6">
        <div className="font-display text-[18vw] leading-none text-white/[0.035] text-center whitespace-nowrap">COOLTRACE</div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pb-10 flex flex-wrap items-center justify-between gap-4">
        <span className="label-mono text-[var(--muted-2)]">© 2026 CoolTrace Solutions Ltd.</span>
        <span className="label-mono text-[var(--muted-2)]">Made in London · Cooling since 2016</span>
      </div>
    </footer>
  );
}

function FootCol({ title, children }) {
  return (
    <div>
      <div className="label-mono text-[var(--muted)] mb-6">{title}</div>
      <ul className="flex flex-col gap-4 text-[14px] text-[#c3cbdb]">{children}</ul>
    </div>
  );
}
